import Calculator from './calculator'

const formulas = {
  type: 'calculateFormula',
  number: 'number',
  timeDifference: 'timeDifference',
  timeDifferenceRange: 'timeDifferenceRange',
  date: 'date'
}

export default Calculator
export {
  formulas
}
